import React from 'react';
import type { Breakpoint } from '../../hooks/useBreakpoint';

// Facts, not aspirations. These four are the numbers the marketing site
// publishes and the compliance page lists by name, so a visitor who arrives
// here from marketing.dataanchor.io sees the same claims. "Illumination",
// "Strategic Partnership" and "Peace of Mind" said nothing a buyer can check.
const pillars = [
  { num: '161', name: 'checks' },
  { num: '13', name: 'control areas' },
  { num: '21', name: 'audit modules' },
  { num: '0', name: 'writes, ever' },
];

interface BrandPillarsProps {
  breakpoint: Breakpoint;
}

const BrandPillars: React.FC<BrandPillarsProps> = ({ breakpoint }) => {
  if (breakpoint === 'mobile') return null;

  const gap = breakpoint === 'smallLaptop' || breakpoint === 'tablet' ? '12px' : '18px';
  const wrap = breakpoint === 'tablet' ? 'flex-wrap' : '';

  return (
    <div
      className={`flex ${wrap} mt-4 pt-[14px] border-t border-white/[0.03]`}
      style={{ gap, animation: 'fadeUp 0.8s cubic-bezier(0.16,1,0.3,1) 0.85s both' }}
    >
      {pillars.map((p) => (
        <div key={p.num} className="flex items-baseline gap-1.5">
          <span className="font-mono text-[11px] font-semibold text-anchor-teal tracking-[0.06em]">{p.num}</span>
          <span className="font-mono text-[10px] font-normal text-white/70 tracking-[0.06em] uppercase">{p.name}</span>
        </div>
      ))}
    </div>
  );
};

export default BrandPillars;
